<template>
  <div id="app">
    <router-view v-if="alive"/>
  </div>
</template>
<script>
  // eslint-disable-next-line no-unused-vars
  import vConsole from 'vconsole'

  export default {
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        alive: true,
      }
    },
    mounted() {
      //new vConsole()
    },
    methods: {
      reload() {
        this.alive = false
        this.$nextTick(() => {
          this.alive = true
        })
      },
    },
  }


</script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    position: fixed;
    overflow-x: hidden;
    overflow-y: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;


    .bottom {
      border-top: 1px solid #cccccc;
    }

    .overtext {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

</style>
